import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FieldDefinition} from '@shared/models/field-definition';
import {PagedResponseRow} from '@shared/models/paged-response-model';
import {DialogModel} from '@shared/models/dialog.model'
import {DialogService} from '@shared/services/dialog-service';
import {TaxFormsService} from '../../../services/tax-forms.service';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {TaxFormSupportiveLanguage} from '../../../models/tax-forms.model';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Subject} from 'rxjs';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Guid} from "guid-typescript";
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {SecurityState} from '@shared/store/reducers/security.reducer';

@Component({
    standalone: false,
    selector: 'particle-tax-forms-actions-cell-viewer',
  templateUrl: './tax-forms-actions-cell-viewer.component.html',
  styleUrls: ['./tax-forms-actions-cell-viewer.component.scss']
})
export class TaxFormsActionsCellViewerComponent implements OnInit, OnDestroy, CellComponent {
  fieldDefinition: FieldDefinition;
  item: PagedResponseRow;
  value: any;
  displayText: string;
  menus: any[];
  supportiveLanguageQueryKey = 'TranslationSupportiveLanguage';
  taxformsSupportiveLanguage: TaxFormSupportiveLanguage[] = [];
  private language$: any;
  unsubscribe$ = new Subject<void>();
  itrceToken: any;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  readonly orbitaxPublicationCompany: string = 'orbitaxpublication';

  constructor(public taxFormsService: TaxFormsService,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private queryStore: Store<IQueryState>,
              private securityStore: Store<SecurityState>) {
    this.menus = [
      {
       id: 0,
       title: 'Download',
       value: 'download'
      },
      {
        id: 1,
        title: 'Compare',
        value: 'compare'
      },
      {
        id: 2,
        title: 'Document Translation',
        value: 'translate'
      },
      {
        id: 3,
        title: 'Convert to Smart Form',
        value: 'create-pdf-form-smart-skill'
      },
      {
        id: 4,
        title: 'Open in Drive',
        value: 'itrce-forms-open-in-drive'
      }
    ];
    this.itrceToken = this.taxFormsService.getItrceAuthToken();
    // console.log('authotoken:', this.itrceToken);
  }

  ngOnInit() {
    this.securityStore.select(getUserInfo).subscribe(userInfo => {
      if (userInfo && userInfo.userName && userInfo.companyId) {
        const companyId = userInfo.companyId;
        this.adjustActionMenuItems(companyId);
      }
    });
    this.displayText = this.item.cells[this.fieldDefinition.key].displayText;
    this.value = this.item.cells[this.fieldDefinition.key].value;
    this.language$ =  this.queryStore.pipe(select(getQueryResponse, this.supportiveLanguageQueryKey), takeUntil(this.unsubscribe$));
    this.language$.subscribe(language => {
      if (language) {
        this.taxformsSupportiveLanguage = language;
        if (this.taxformsSupportiveLanguage && this.taxformsSupportiveLanguage.length > 0) {
          this.taxformsSupportiveLanguage.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            } else if (a.name === b.name) {
              return 0;
            } else {
              return 1;
            }
          });
        }
      }
    });
    QueryProvider.invokeQuery(this.queryStore, this.supportiveLanguageQueryKey, {});
  }

  onClickAction(value: any) {
    switch (value) {
      case 'download':
        this.download();
        break;
      case 'compare':
        this.compare();
        break;
      case 'translate':
        this.translate();
        break;
      case 'create-pdf-form-smart-skill':
        this.createPdfFormSmartSkill();
        break;
      case 'itrce-forms-open-in-drive':
        this.openInDrive();
        break;
    }
  }

  download() {
    //extra parameter added for Activity Tracking
    this.taxFormsService.downloadFormWithId(this.item.id, this.item.cells.FormInfo.value.form.categoryCode, this.item.cells.FormInfo.value.form.name, this.item.cells.FormInfo.value.form.countryName);
  }
  compare() {
    const payload = {
      item: this.item,
      fieldDefinition: this.fieldDefinition,
      action: 'Grid-Compare',
      formInfo: this.item.cells['FormInfo'].value
    };
    this.valueChanged.emit(payload);
  }
  translate() {
    let translationId = Guid.create().toString();
    const dialogModel: DialogModel = DialogModel.create(
      'Translate Options',
      'FormGridTranslationDialogComponent',
      {taxformsSupportiveLanguage: this.taxformsSupportiveLanguage, translationId: translationId},
      '700px',
      '700px'
    );
    dialogModel.okCaption = 'Translate';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        this.emitConvertedTranslateFileEvent(res.data.input.translate, translationId);
      }
    });

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private emitTranslateFileEvent(translate: any) {
    const payload = {
      item: this.item,
      fieldDefinition: this.fieldDefinition,
      action: 'Grid-Translate',
      translationConfig: {
        formId: this.item.id,
        translateTo: translate.toLanguage,
        isFileScanned: translate.isFileScanned,
        toolName: 'Forms',
        isForm: true,
        translateFrom: this.item.cells['Language'].value
      }
    };
    this.valueChanged.emit(payload);
  }

  private emitConvertedTranslateFileEvent(translate: any, translationId: string) {
    this.fuseSplashScreenService.show();
    this.taxFormsService.getConvertedTaxformsId(this.item.id, translationId).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      this.fuseSplashScreenService.hide();
      console.log('formId:', res);
      const payload = {
        item: this.item,
        fieldDefinition: this.fieldDefinition,
        action: 'Grid-Translate',
        translationConfig: {
          formId: res,
          translateTo: translate.toLanguage,
          isFileScanned: translate.isFileScanned,
          toolName: 'Forms',
          isForm: true,
          formName: `${this.item.cells['FormName'].displayText}.pdf`,
          translateFrom: this.item.cells['Language'].value,
          translationId: translationId,
          storageSettings: translate.storageSettings
        }
      };
      this.valueChanged.emit(payload);
    });
  }
  private createPdfFormSmartSkill() {
    const payload = {
      item: this.item,
      fieldDefinition: this.fieldDefinition,
      action: 'Create-pdf-form-smart-skill',
      formInfo: this.item.cells['FormInfo'].value
    };
    this.valueChanged.emit(payload);
  }

  private openInDrive() {
    // todo: unify
    const payload = {
      item: this.item,
      fieldDefinition: this.fieldDefinition,
      action: 'Itrce-forms-open-in-drive',
      formInfo: this.item.cells['FormInfo'].value
    };
    this.valueChanged.emit(payload);
  }

  private adjustActionMenuItems(companyId: any) {
    if (companyId !== this.orbitaxPublicationCompany) {
      this.menus = this.menus.filter(menu => menu.value !== 'create-pdf-form-smart-skill');
    }
  }
}
